(ns superadmin.resource.id-lookup
  "Resource for ID lookup functionality"
  (:require [common.url-template :as url-tpl]
            [re-frame.core :as rf]))

(rf/reg-event-fx :superadmin-resource.id-lookup/search
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db url-context :resource.user/token]} [_ id]]
    {:db (assoc db :superadmin-resource.id-lookup/results {:state :pending :value nil})
     :http
     {:method :get
      :uri (url-tpl/render :superadmin-api/id-lookup url-context {:id id})
      :headers {"Authorization" token}
      :on-success [:superadmin-resource.id-lookup/search-success]
      :on-failure [:superadmin-resource.id-lookup/search-failure]}}))

(rf/reg-event-db :superadmin-resource.id-lookup/search-success
  (fn [db [_ response]]
    (assoc db :superadmin-resource.id-lookup/results {:state :success :value (:results response)})))

(rf/reg-event-fx :superadmin-resource.id-lookup/search-failure
  (fn [{:keys [db]} _]
    {:db (assoc db :superadmin-resource.id-lookup/results {:state :failure :value nil})
     :dispatch [:toaster-bus/add {:id ::search-failure
                                  :type :error
                                  :message "Failed to lookup ID"}]}))

(rf/reg-sub :superadmin-resource.id-lookup/results
  (fn [db _]
    (:superadmin-resource.id-lookup/results db)))
